import React from "react";
import { InactiveText } from "./Grid.styles";
import { CellRendererProps } from "./types";

export const InactiveCell: React.FC<CellRendererProps> = ({ value }) => (
  <InactiveText>{value}</InactiveText>
);
